var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('feather-icon',{staticClass:"hover:text-danger cursor-pointer",attrs:{"icon":"Trash2Icon","svgClasses":"h-5 w-5"},on:{"click":_vm.confirmDeleteRecord}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }